<template>
  <div class="bi-table-card bottom-box">
    <div class="bi-table-card--items">
      <div
        v-for="campaign of adCampaigns.results"
        :key="campaign.id"
        class="bi-table-card--item campaign-item"
      >
        <div class="bi-table-card--item-details">
          <router-link
            :to="{ name: 'bi.campaigns.edit', params: { id: campaign.id } }"
            ><h5>{{ campaign.name }}</h5></router-link
          >
          <p v-if="campaign.userGroup">
            <i class="fas fa-briefcase"></i>{{ campaign.userGroup.name }}
          </p>
          <p v-if="campaign.dateStop">
            <i class="fas fa-clock"></i
            >{{ $d(new Date(campaign.dateStop), "short") }}
          </p>
          <p></p>
        </div>
        <div class="bi-table-card--item-source">
          <template v-if="campaign.facebookInsightsCount">
            <span class="channel fb" title="Facebook"
              ><i class="fab fa-facebook-f"></i
            ></span>
            <!-- <span class="channel instagram"
              ><i class="fab fa-instagram"></i
            ></span> -->
          </template>
          <span
            v-if="campaign.cleverreachReportsCount"
            title="Cleverreach"
            class="channel cr"
            ><i class="fal fa-mail-bulk"></i
          ></span>
          <span
            v-if="campaign.googleAdsCount"
            title="Google"
            class="channel google"
            ><i class="fab fa-google"></i
          ></span>
        </div>
      </div>
    </div>
    <div class="bi-table-card-link">
      <router-link :to="{ name: 'bi.campaigns' }" class="overview-link">
        Alle Kampagnen anzeigen <i class="fal fa-arrow-right"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  data() {
    return {
      adCampaigns: {},
      currentPage: 1,
      paginationPageSize: 7,
      filter: {
        search: null,
        vacancy: null
      }
    };
  },
  apollo: {
    adCampaigns: {
      query: gql`
        query adCampaigns($page: Int!, $size: Int, $filter: AdCampaignFilter) {
          adCampaigns(page: $page, size: $size, filter: $filter) {
            total
            results {
              id
              number
              name
              dateStop
              facebookInsightsCount
              cleverreachReportsCount
              googleAdsCount
              userGroup {
                id
                name
              }
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          page: Number(this.currentPage),
          size: Number(this.paginationPageSize),
          filter: {
            search: this.filter.search
          }
        };
      }
    }
  }
};
</script>
